export const SNAPSHOT_STATUS = {
  NO_SNAPSHOT: 'no_snapshot',
  SNAPSHOTTING: 'snapshotting',
  TAKEN: 'taken',
};
